var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    class: {
      'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "weui-mask",
    style: _vm.maskStyle,
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.hide($event);
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    class: _vm.dialogClass,
    style: _vm.dialogStyle
  }, [_vm._t("default")], 2)])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };